var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgChooseFile = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 68,
    viewBox: "0 0 79 68",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9106 48.0535L56.8205 32.1436C57.7968 31.1673 57.7968 29.5844 56.8205 28.608C55.8442 27.6317 54.2613 27.6317 53.285 28.608L41.6429 40.2502V2.16067e-07L36.6429 0V40.2502L25.0007 28.608C24.0244 27.6317 22.4415 27.6317 21.4652 28.608C20.4889 29.5844 20.4889 31.1673 21.4652 32.1436L37.3751 48.0535C38.3514 49.0298 39.9343 49.0298 40.9106 48.0535ZM5 54.9286V38.5714H0V54.9286C0 61.8321 5.59645 67.4286 12.5 67.4286H65.7857C72.6893 67.4286 78.2857 61.8321 78.2857 54.9286V38.5714H73.2857V54.9286C73.2857 59.0707 69.9278 62.4286 65.7857 62.4286H12.5C8.35787 62.4286 5 59.0707 5 54.9286Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChooseFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chooseFile.f0417835.svg";
export { ForwardRef as ReactComponent };